import React, { useEffect, useState } from "react";
import classes from "./TodoWithoutFinishingOnBoarding.module.css";
import { SideBarMenu } from "../../../../stories/SideBarMenu/SideBarMenu";
import { Col, Container, Row } from "react-bootstrap";
import {
  AllStepsRocketImg,
  ArrowUpRightBlue,
  CheckCircleIconGreen,
  BlueSmileIcon,
  CancelredIcon,
  CheckGreen28,
} from "../../../../constant/imagePath";
import AllSteps from "../../../../Pages/CoachFlow/OnBoarding/AllSteps/AllSteps";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Button } from "../../../../stories/Button/Button";
import { ReactSVG } from "react-svg";

export default function TodoWithoutFinishingOnBoarding({
  setIsFinishOnBoarding,
}) {
  const [isFinish, setIsFinish] = useState(false);

  function handleConditionalChange() {
    setIsFinish(true);
    setTimeout(() => {
      setIsFinishOnBoarding(true);
    }, 5000);
  }

  const stepsData = [
    {
      stepTitle: "Step 1",
      heading: "Getting to know you",
      tagline: "Your background, experience, and expertise",
      linkText: "Edit",
      isDone: true,
    },
    {
      stepTitle: "Step 2",
      heading: "Setting up your lesson",
      tagline: "You will be coaching 1-on-1 tennis near San Diego",
      linkText: "Edit",
      isDone: true,
    },
    {
      stepTitle: "Step 3",
      heading: "Set your schedule",
      tagline: "Availability and pricing",
      linkText: "Edit",
      //   isDone: "",
    },
  ];

  return (
    <div className={classes.todo}>
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col md={4}>
            <div className={classes.left}>
              <div
                className={classes.oneMoreStepToGo}
                style={{ backgroundImage: `url(${AllSteps})` }}
              >
                <p
                  className={classes.headline}
                  style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}
                >
                  {isFinish ? "Edit your onboarding" : "Finish your onboarding"}
                </p>
                <h1 style={{ ...Fonts.h1, color: Colors.neutralShadesOfNero }}>
                  One More Step To Go!
                </h1>
                {/* Smily With Text */}
                <div className={classes.smilyWithText}>
                  <ReactSVG src={BlueSmileIcon} beforeInjection={(svg)=>svg.classList.add(classes.icon )}/>
                  <p
                    style={{
                      ...Fonts.p3,
                      color: isFinish
                        ? Colors.mainBlue
                        : Colors.neutralShadesOfDimGray,
                        fontStyle: "italic"
                    }}
                  >
                    {isFinish
                      ? "Your application is on the review"
                      : "You’ll be a Coach soon! Just add the last few details to your listings."}
                  </p>
                </div>
                <img src={AllStepsRocketImg} className={classes.rocketImg} />
              </div>
            </div>
          </Col>
          <Col md={8} className={[classes.scrollDivHeight].join(" ")}>
            <div className={classes.right}>
              <Row className={["g-0", classes.firstRow].join(" ")}>
                {stepsData?.map((item) => {
                  return (
                    <Col md={12}>
                      <div
                        className={classes.stepCard}
                        style={{
                          borderBottomColor: Colors.neutralShadesOfWhisper,
                        }}
                      >
                        <div className={classes.stepTitleWithIcon}>
                          <p
                            className={classes.stepTitle}
                            style={{ ...Fonts.input3, fontFamily: "inter-500" }}
                          >
                            {item?.stepTitle}
                          </p>
                          <ReactSVG
                            src={
                              item?.isDone == true
                                ? CheckGreen28
                                : CancelredIcon
                            }
                            beforeInjection={(svg)=>svg.classList.add(classes.icon)}
                            
                          />
                        </div>
                        <h4 style={{ ...Fonts.h4, fontSize: "26px" }}>
                          {item?.heading}
                        </h4>
                        <p className={classes.tagline} style={{ ...Fonts.p1 }}>
                          {item?.tagline}
                        </p>
                        <LinkButtonWithIcon
                          primary={true}
                          text={item?.linkText}
                          rightIcon={ArrowUpRightBlue}
                          iconStyle={{ margin: "0px" }}
                        />
                      </div>
                    </Col>
                  );
                })}
              </Row>
              {/* Finish Button */}
              {!isFinish && (
                <div className={classes.finishBtnDiv}>
                  <Button
                    label={"Finish"}
                    customStyle={{
                      ...Fonts.b1,
                      width: "156px",
                      height: "56px",
                    }}
                    primary={true}
                    onClick={() => {
                      handleConditionalChange();
                    }}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
